import { createGlobalStyle } from 'styled-components';

import adobeCaslon from '../assets/fonts/ACaslonPro-Regular.woff';
import adobeCaslonItalic from '../assets/fonts/ACaslonPro-Italic.woff';

import albertus from '../assets/fonts/AlbertusMTStd-Light.woff';
import albertusItalic from '../assets/fonts/AlbertusMTStd-Italic.woff';

import avenirBlack from '../assets/fonts/AvenirLTStd-Black.woff';
import avenirBlackItalic from '../assets/fonts/AvenirLTStd-BlackOblique.woff';
import avenirBook from '../assets/fonts/AvenirLTStd-Book.woff';
import avenirBookItalic from '../assets/fonts/AvenirLTStd-BookOblique.woff';
import avenirLight from '../assets/fonts/AvenirLTStd-Light.woff';
import avenirLighttalic from '../assets/fonts/AvenirLTStd-LightOblique.woff';

import baskerville from '../assets/fonts/NewBaskervilleStd-Roman.woff';
import baskervilleBold from '../assets/fonts/NewBaskervilleStd-Bold.woff';
import baskervilleItalic from '../assets/fonts/NewBaskervilleStd-Italic.woff';
import baskervilleBoldItalic from '../assets/fonts/NewBaskervilleStd-BoldIt.woff';

const Typography = createGlobalStyle`
  @font-face {
    font-family: 'Caslon';
    src: url(${adobeCaslon});
    font-style: normal;
  }
  @font-face {
    font-family: 'Caslon';
    src: url(${adobeCaslonItalic});
    font-style: italic;
  }
  @font-face {
    font-family: 'Baskerville';
    src: url(${baskerville});
    font-style: normal;
  }
  @font-face {
    font-family: 'Baskerville';
    src: url(${baskervilleItalic});
    font-style: italic;
  }
  @font-face {
    font-family: 'Baskerville';
    src: url(${baskervilleBold});
    font-style: normal;
    font-weight: bold;
  }
  @font-face {
    font-family: 'Baskerville';
    src: url(${baskervilleBoldItalic});
    font-style: italic;
    font-weight: bold;
  }
  @font-face {
    font-family: 'Albertus';
    src: url(${albertus});
    font-style: normal;
  }
  @font-face {
    font-family: 'Albertus';
    src: url(${albertusItalic});
    font-style: italic;
  }
  @font-face {
    font-family: 'Avenir';
    src: url(${avenirBook});
    font-style: normal;
    font-weight: normal;
  }
  @font-face {
    font-family: 'Avenir';
    src: url(${avenirBookItalic});
    font-weight: normal;
    font-style: italic;
  }
  @font-face {
    font-family: 'Avenir';
    src: url(${avenirLight});
    font-style: normal;
    font-weight: lighter;
  }
  @font-face {
    font-family: 'Avenir';
    src: url(${avenirLighttalic});
    font-style: italic;
    font-weight: lighter;
  }
  @font-face {
    font-family: 'Avenir';
    src: url(${avenirBlack});
    font-style: normal;
    font-weight: bold;
  }
  @font-face {
    font-family: 'Avenir';
    src: url(${avenirBlackItalic});
    font-style: italic;
    font-weight: bold;
  }
  
  html {
    font-family: Baskerville, serif;
    color: var(--black);
  }

  // Logo
  footer .logo,
  h1.logo,
  h2.logo,
  section.intro h2 {
    font-family: Albertus, serif;
  }

  // Titles
  .legend .title,
  h1, h2, h3, h4 {
    margin-top: 0;
    font-family: Caslon, serif;
    font-weight: normal;
    text-transform: uppercase;
  }

  // Buttons
  .button,
  button {
    font-family: Avenir, sans-serif;
    font-weight: normal;
  }
  .collapsible {
    button.title {
      font-family: Caslon, serif;
    }
  }

  // Quotes
  blockquote {
    font-family: Caslon, serif;
    font-weight: normal;
    font-size: var(--fsQuote);
  }

  .block:not(.noByline) {
    blockquote {
      // Names under quotes
      em {
        font-family: Avenir, sans-serif;
        font-weight: normal;
        font-style: normal;
        font-size: var(--fsDetails);
        display: block;
      }
    }
  }

  // Numbers in legends
  .legend {
    &.size p,
    &.levels p {
      font-family: Avenir, sans-serif;
      font-weight: normal; 
    }
  }

  // Footer
  footer {
    font-family: Avenir, sans-serif;
    font-weight: lighter;
  }

  // Master plan details
  section.masterPlan strong {
    font-family: Avenir, sans-serif;
    font-weight: bold;
  }
`;

export default Typography;
